export const DATE_FORMAT_LONG = "DD/MM/YYYY HH:mm:ss";
export const DATE_FORMAT_LONG_WITHOUT_SECONDS = "DD/MM/YYYY HH:mm";
export const DATE_FORMAT_HOUR_AND_MINUTES = "HH:mm";
export const DATE_FORMAT_SHORT = "DD/MM/YYYY";

export const OPERATOR_LTE = 'time_lte';
export const OPERATOR_GTE = 'time_gte';
export const OPERATOR_GT = 'time_gt';
export const OPERATOR_LT = 'time_lt';

import moment from 'moment';

var DatesMixin = {
  methods: {
    getFormattedDateLong(date) {
      return moment(date).format(DATE_FORMAT_LONG_WITHOUT_SECONDS);
    },
    getFormattedDateShort(date) {
      return moment(date).format(DATE_FORMAT_SHORT);
    },
    getTime(date) {
      return moment(date).format(DATE_FORMAT_HOUR_AND_MINUTES);
    },
    getEpoch(date) {
      const epoch = date.getTime();
      return epoch;
    },
    getMondayOfCurrentWeek(d) {
      var day = d.getDay();
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() + (day == 0 ? -6 : 1) - day);
    },
    getSundayOfCurrentWeek(d) {
      var day = d.getDay();
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() + (day == 0 ? 0 : 7) - day);
    },
    getFirstDayOfCurrentMonth(d) {
      return new Date(d.getFullYear(), d.getMonth(), 1);
    },
    getLastDayOfCurrentMonth(d) {
      return new Date(d.getFullYear(), d.getMonth() + 1, 0);
    },
    getFirstDayOfCurrentYear(d) {
      return new Date(d.getFullYear(), 0, 1);
    },
    getLastDayOfCurrentYear(d) {
      return new Date(d.getFullYear(), 12, 0);
    },
    buildFilterBetween(dateField, start, end) {
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      var secondsSinceEpochStart = this.getEpoch(start);
      var secondsSinceEpochEnd = this.getEpoch(end);
      return [
        dateField + "~" + OPERATOR_GTE + "=" + secondsSinceEpochStart,
        dateField + "~" + OPERATOR_LTE + "=" + secondsSinceEpochEnd
      ]
    },
    buildFilterLessToday(dateField) {
      var start = new Date();
      var end = new Date(start.getTime());
      end.setHours(23, 59, 59, 999);
      var secondsSinceEpochEnd = this.getEpoch(end);
      return [
        dateField + "~" + OPERATOR_LTE + "=" + secondsSinceEpochEnd
      ]
    },
    utcTimestamp(dateString) {
      var dateFormatted = new Date(dateString).getTime(); // moment.utc(dateString).valueOf()
      return dateFormatted;
    }
  }
};
export default DatesMixin;